/* eslint-disable no-console */

const csrfToken = () => document.querySelector('meta[name="csrf-token"]').content;

export const fetchChatkitConversation = async () => {
  try {
    const res = await fetch('/ai/chatkit_conversation', {
      headers: { Accept: 'application/json' }
    });
    if (!res.ok) throw new Error();
    return res.json();
  } catch (error) {
    console.error('Error fetching chatkit conversation:', error);
    return null;
  }
};

export const destroyChatkitConversation = async () => {
  try {
    const res = await fetch('/ai/chatkit_conversation', {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': csrfToken() }
    });
    if (!res.ok) throw new Error();
    return res.ok;
  } catch (error) {
    console.error('Error destroying chatkit conversation:', error);
    return false;
  }
};
